module.exports = __webpack_public_path__ + "static/media/haemmernd.eb3172c2.jpg";